import React from 'react';
import { useHistory } from 'react-router-dom';

import { MembershipBannerCopy, openMembershipPath } from 'utils/membership';

type MembershipBannerMessageProps = {
  copy: MembershipBannerCopy;
};

const MembershipBannerMessage: React.FC<MembershipBannerMessageProps> = ({ copy }) => {
  const history = useHistory();
  const action = copy.inlineAction;
  const actionIndex = action ? copy.body.indexOf(action.label) : -1;

  if (!action || actionIndex < 0) return <>{copy.body}</>;

  return (
    <>
      {copy.body.slice(0, actionIndex)}
      <a
        href={action.path}
        onClick={(event) => {
          event.preventDefault();
          openMembershipPath(history, action.path);
        }}
        style={{ color: 'inherit', fontWeight: 600, textDecoration: 'underline' }}
      >
        {action.label}
      </a>
      {copy.body.slice(actionIndex + action.label.length)}
    </>
  );
};

export default MembershipBannerMessage;
